import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { movePageIndex, toggleSideView , showInputMeta, setCheckMeta, setRadioMeta } from '../actions'

import _ from 'lodash'

import SideBar from '../components/side'
import MetaLayer from '../components/MetaLayer'

import './content.css'

class Content extends Component {
    renderMeta() {
        let metas = []
        _.each(this.props.metaItems, (value, key) => {
            let filtered = _.filter(value, (value) => value.pageIndex === this.props.currentIndex)
            metas = metas.concat(filtered)
        })

        return <MetaLayer metas={metas} showRatio={this.props.showRatio * this.props.docRatio} showInputMeta={this.props.showInputMeta} setCheckMeta={this.props.setCheckMeta} setRadioMeta={this.props.setRadioMeta} />
    }

    renderSideBar() {
        if (this.props.showSideView) {
            return <SideBar tocInfo={this.props.tocItems} movePageIndex={this.props.movePageIndex} toggleSideView={this.props.toggleSideView}/>
        }
    }

    renderTSA() {
        if (this.props.isTSA) {
            let matchTSA = this.props.TSATime.length > 0
            let pWidth = this.props.pageInfo.w * this.props.showRatio * this.props.docRatio
            let tSize = 100 * this.props.showRatio * this.props.docRatio
            let position = {
            left: pWidth - tSize + 'px',
            width: tSize + 'px',
            height: tSize + 'px',
            backgroundImage: 'url('+require("../image/kftc_tsa_bg.png")+')',
            backgroundSize: 'cover',
            fontSize: (matchTSA ? 12 : 18) * this.props.showRatio * this.props.docRatio + 'px',
            }

            return (
            <div className="TSALayout" style={position}>
                { this.renderTSATime(matchTSA) }
            </div>)  
        }
    }

    renderTSATime(matchTSA) {
        if (matchTSA) {
            let date = this.props.TSATime.split(" ")
            return (
                <div className="TSAText">
                    <text>진본{<br/>}{date[0]}{<br/>}{date[1]}</text>
                </div>
            )
        }

        return (
            <div className="TSATextN">
                <text style={{color: 'red'}}>위변조</text>
            </div>
        )
    }

    renderContent() {
        if (this.props.image) {
            let zoom = {
                'maxWidth': this.props.pageInfo.w * this.props.showRatio * this.props.docRatio + 'px',
                'maxHeight': this.props.pageInfo.h * this.props.showRatio * this.props.docRatio + 'px',
            }
            return (
                <div className="frame">
                    <div style={zoom} className="metaBase">
                        <img style={zoom} src={this.props.image} role="presentation" />
                        { this.renderMeta() }
                        { this.renderTSA() }
                    </div>
                </div>
            )
        }
    }
    
    render() {
        return (
            <div className="Content">
              { this.renderSideBar() }
              { this.renderContent() }
            </div>
        );
    }
}

Content.propTypes = {
    showSideView: PropTypes.bool.isRequired,
    showRatio: PropTypes.number.isRequired,
    docRatio: PropTypes.number.isRequired,

    currentIndex: PropTypes.number,
    image: PropTypes.string,
    pageInfo: PropTypes.object,

    metaItems: PropTypes.object,
    tocItems: PropTypes.array,

    movePageIndex: PropTypes.func,
    toggleSideView: PropTypes.func,
    showSignInput: PropTypes.func,
}

function mapStateToProps(state) {
    function getImageUrl(pageImage) {
        if (pageImage !== undefined) {
            if (pageImage.items.data !== undefined) {
                return pageImage.items.data.imageUrl
            }
        }
        return ''
    }

    function getPageInfo(pageInfo) {
        if (pageInfo !== undefined) {
            if (pageInfo.items.data !== undefined) {
                return pageInfo.items.data.pageSize
            }
        }
        return {}
    }

    function getMetaInfo(metaInfo) {
        if (metaInfo !== undefined) {
            if (metaInfo.items.data !== undefined) {
                return metaInfo.items.data
            }
        }
        return {}
    }

    const { extra, viewer } = state
    const { openStatus } = viewer

    let image = getImageUrl(viewer.pageImage)
    let pageInfo = getPageInfo(viewer.pageInfo)
    let metaData = getMetaInfo(viewer.metaInfo)
    return {
        showSideView: extra.showSideView,
        showRatio: extra.showRatio,
        docRatio: extra.docRatio,
        currentIndex: viewer.index,
        image: image,
        pageInfo: pageInfo,
        metaItems: metaData.metaInfo === undefined ? {} : metaData.metaInfo.metaItems,
        tocItems: metaData.tocInfo === undefined ? [] : metaData.tocInfo.tocItems,
        hasTSA: openStatus.fileInfo ? openStatus.fileInfo.hasTSA : false,
        TSATime: openStatus.fileInfo ? openStatus.fileInfo.TSATime : '',
        isTSA: openStatus.fileInfo ? openStatus.fileInfo.isTSA : false,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        movePageIndex: (index) => dispatch(movePageIndex(index)),
        toggleSideView: () => dispatch(toggleSideView()),
        showInputMeta: (index, metatype) => dispatch(showInputMeta(index, metatype)),
        setCheckMeta: (index, value) => dispatch(setCheckMeta(index, value)),
        setRadioMeta: (index, group, value) => dispatch(setRadioMeta(index, group, value)),
    }
}

export default connect (mapStateToProps, mapDispatchToProps)(Content)



// WEBPACK FOOTER //
// ./src/containers/content.js